import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// Connects to data-controller="filtra-assuntos"
export default class extends Controller {
  static values  = { url: String }
  static targets = [ "select_assuntos" ]

  change() {
    const colecao_id = this.element.value
    this.fetchAssuntos(colecao_id)
  }

  async fetchAssuntos(colecao_id) {
    await get(`${this.urlValue}?colecao_id=${colecao_id}`, {responseKind: "turbo-stream"});
  }
}
